import useMedia from "react-use/lib/useMedia";

export const useIsMobileUp = () =>
  useMedia("only screen and (min-width: 480px");
export const useIsTabletUp = () =>
  useMedia("only screen and (min-width: 768px)");
export const useIsDesktopUp = () =>
  useMedia("only screen and (min-width: 1024px");

export const useIsTabletDown = () => useMedia("(max-width: 1024px)");
export const useIsMobile = () => useMedia("(max-width: 767px)");
